import React, { memo } from 'react';

import { RMAXLogger } from '../../../services/LoggerService/RMAXLogger';
import { SaveAltSharp } from '@material-ui/icons';
import Tooltip from '../../../components/common/StyledToolTip';
import { compose } from 'recompose';
import { csvFormulaInjectionSanitizer } from '../../../utilities/csvUtils';
import styles from './styles';
import { withStyles } from '@material-ui/core';

const ExportData = ({ gridApi,stack, stackIndex, name, userData, classes, showLabel }) => {
  const getVisibleColumnIds = () => {
    let columnKeys = [];
    const columns = gridApi.getColumns();
    columnKeys = columns
      .filter(column => column.colDef.headerName && column.visible)
      .map(column => column.getColId());
    return columnKeys;
  };

  const exportCSV = () => {
    if (!gridApi) {
      return;
    }
    const gridName = gridApi.gridName ||  stack.config.content[stackIndex].title;
    const scenarioName = name || userData.userProfile.scenarioName;
    const columnKeys = getVisibleColumnIds();
    let params = {
      fileName: `${gridName}_${scenarioName}.csv`,
      columnKeys,
      processCellCallback: (cell) => csvFormulaInjectionSanitizer(cell.value)
    };
    gridApi.exportDataAsCsv(params);

    RMAXLogger.info('GridDataDownload', { gridName });
  };

  return (
    <div
      className={`${showLabel ? classes.iconWithLabel : classes.headerIconStyles} ${
        classes.iconLayout
      } glHeaderIcons ${classes.enabledIcon}`}
      onClick={exportCSV}>
      <Tooltip title={showLabel ? "" : "Export Data"}>
        <SaveAltSharp />
      </Tooltip>
      {showLabel && <span className={classes.iconLabel}>Export Data</span>}
    </div>
  );
};

export default compose(withStyles(styles))(memo(ExportData));
